import React, { useEffect, useState } from 'react';
import { Box, FormControlLabel, Checkbox } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const styles = {
  formControl: {
    margin: '16px 0 0 0',
    width: '100%',
  },
  label: {
    fontSize: 14,
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.6)',
  },
};

const useStyles = makeStyles(styles);

const CheckboxComp = props => {
  const classes = useStyles();
  const {
    docuSignTabMap,
    handleBlur,
    setReference,
    setReferenceToRequiredFunction,
    setReferenceToErrorsValueFunction,
    index,
  } = props;

  const [value, setValue] = useState(
    docuSignTabMap.value === true || docuSignTabMap.value === 'true' || docuSignTabMap.value === 'Yes'
  );
  const [required, setRequired] = useState(docuSignTabMap.required);
  const [errors, setErrors] = useState(docuSignTabMap.errors);

  const setRequiredValue = newRequiredValue => {
    setRequired(newRequiredValue);
  };

  const setErrorsValue = errors => {
    setErrors(errors);
  };

  setReference(docuSignTabMap.label, v => {
    const boolValue = v === true || v === 'true' || v === 'Yes';
    setValue(boolValue);
    handleBlur(boolValue, index);
  });
  setReferenceToRequiredFunction(docuSignTabMap.label, setRequiredValue);
  setReferenceToErrorsValueFunction(docuSignTabMap.label, setErrorsValue);

  useEffect(() => {
    if (docuSignTabMap.value !== value) {
      const boolValue =
        docuSignTabMap.value === true || docuSignTabMap.value === 'true' || docuSignTabMap.value === 'Yes';
      setValue(boolValue);
    }
  }, [props]);

  const handleChange = event => {
    const newValue = event.target.checked;
    setValue(newValue);
    handleBlur(newValue, index);
  };

  return (
    <Box component="form" noValidate autoComplete="off" key={index} style={{ width: '100%' }}>
      <FormControlLabel
        className={classes.formControl}
        control={<Checkbox checked={value} onChange={handleChange} color="primary" />}
        label={(required ? '* ' : '') + docuSignTabMap.label}
        classes={{
          label: classes.label,
        }}
        style={{ marginLeft: '-11px' }}
      />
      {errors && errors.length > 0 && (
        <div style={{ color: 'red', fontSize: '0.75rem' }}>{errors.map(e => e.message).join(', ')}</div>
      )}
    </Box>
  );
};

export default CheckboxComp;
